import { z } from 'zod'
import { Currency } from '../../enums/currency.enum'
import { InterestDirection } from '../../enums/interest-direction.enum'

export const createDepositSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters').max(100),
  currency: z.nativeEnum(Currency),
  balance: z.number().nonnegative(),
  interestRate: z.number().positive().max(100),
  termMonths: z.number().int().positive(),
  openDate: z.string().datetime({ offset: true }),
  interestDirection: z.nativeEnum(InterestDirection),
  targetAccountId: z.string().guid(),
  incomeCategoryId: z.string().guid(),
})

export type CreateDepositDto = z.infer<typeof createDepositSchema>
